import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HeartPulse } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/* PWA launch route (manifest start_url): signed-in members land on the
   Today screen; visitors land on the homepage. */
export default function AppStart() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (loading) return;
    nav(user ? "/my-social-pulse" : "/", { replace: true });
  }, [user, loading, nav]);
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3" data-testid="app-start">
      <HeartPulse className="w-10 h-10 text-blue-700 animate-pulse" />
      <p className="text-sm text-zinc-500">Opening your SocialPulse…</p>
    </div>
  );
}
